/* eslint-disable prefer-destructuring */
export const customTags = (tags) => {
  const separator = '::';
  const fromTags = {};
  for (let i = 0; i < tags.length; i += 1) {
    fromTags[tags[i].split(separator)[0]] = tags[i].split(separator)[1];
  }
  return fromTags;
};
